import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 0C0.447715 0 0 0.447715 0 1V23C0 23.5523 0.447715 24 1 24H16C11.9204 24 8.55399 20.9463 8.06189 17H3V15H8.06189C8.19681 13.9181 8.54778 12.9032 9.07026 12H3V10H10.7084C12.1186 8.75527 13.9711 8 16 8C17.4571 8 18.8233 8.38958 20 9.07026V7C20 6.73478 19.8946 6.48043 19.7071 6.29289L13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0H1ZM13 2V7H18L13 2ZM16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12ZM10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16C22 17.2958 21.5892 18.4957 20.8907 19.4765L23.7071 22.2929L22.2929 23.7071L19.4765 20.8907C18.4957 21.5892 17.2958 22 16 22C12.6863 22 10 19.3137 10 16Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }